module.exports = __webpack_public_path__ + "static/img/left_gift.dc70d30c.png";